export type Rule = (v: unknown) => string | boolean;

export const username =
  (t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v === 'string') {
      const pattern = /^[A-Za-z0-9\-@_%#*.,!\x20]+$/;
      if (!pattern.test(v)) return t('lcp.value_invalid');

      return true;
    }

    return false;
  };

export const minLength =
  (length: number, t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v === 'string') {
      if (v.length < length) {
        return t('lcp.at_least_min_length_characters', { min_length: length });
      }
      return true;
    }
    return false;
  };

export const nonRequiredMinLength =
  (length: number, t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v === 'string') {
      if (v.length === 0) {
        return true;
      }

      if (v.length < length) {
        return t('lcp.at_least_min_length_characters', { min_length: length });
      }
      return true;
    }
    return true;
  };

export const maxLength =
  (length: number, t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v === 'string') {
      if (v.length >= length) {
        return t('lcp.at_most_max_length_characters', { max_length: length });
      }
      return true;
    }
    return false;
  };

export const email =
  (t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v === 'string') {
      if (!v) return true;
      // matches ajv-formats "email" to make sure frontend and backend validation are aligned
      // see https://github.com/ajv-validator/ajv-formats/blob/master/src/formats.ts
      const pattern =
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
      if (!pattern.test(v)) return t('lcp.email_invalid');
      return true;
    }

    return true;
  };

export const phoneNumber =
  (t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v !== 'string') {
      return false;
    }

    const pattern = /^\+[1-9]\d{6,14}$/;
    if (!pattern.test(v)) return t('lcp.sms_invalid');

    return true;
  };

export const bankId =
  (t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v !== 'string') {
      return false;
    }

    const pattern = /^((19)|(2[0-3]))\d{2}((0[1-9])|(1[0-2]))((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))\d{4}$/;
    if (!pattern.test(v)) return t('lcp.bankid_invalid');
    return true;
  };

export const required =
  (t: (key: string, ...params: unknown[]) => string): Rule =>
  (v: unknown) => {
    if (typeof v === 'boolean' || typeof v === 'number') {
      return true;
    }

    if (!v) {
      return t('lcp.required');
    }

    return true;
  };
